import type { ExtractPropTypes } from "vue";
import type TzjPlayer from "./tzj-player.vue";

export const TzjPlayerProps = {
  /**
   * 视频地址
   */
  url: {
    type: String,
    default: "",
  },
  /**
   * 访问令牌
   */
  accessToken: {
    type: String,
    default: "",
  },
  /**
   * 视频标题
   */
  areaName: {
    type: String,
    default: "",
  },
  /**
   * 视频ID
   */
  deviceSerial: {
    type: String,
    default: "",
  },
  /**
   * 视频平台类型名称
   */
  platformTypeName: {
    type: String,
    default: "",
  },
  debug: {
    type: Boolean,
    default: false,
  },
  /**
   * 播放器暂停模式
   * 1 - 不暂停（默认）
   * 2 - 初始默认暂停
   * 3 - 初始默认暂停并且每60分钟触发一次暂停
   */
  pauseMode: {
    type: Number,
    default: 1,
    validator: (value: number) => [1, 2, 3].includes(value),
  },
};

export function uuid(): string {
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 是否为支持的协议
 * 支持：http,https,ws,wss,ezopen(萤石云)
 *  当URL不包含协议时（相对地址），也返回true
 */
export function isSupportedProtocol(url: string): boolean {
  if (!url || typeof url !== "string") {
    return false;
  }

  // 如果URL不包含协议部分（相对地址），返回true
  if (!url.includes("://")) {
    return true;
  }

  const protocolRegex = /^(https?|wss?|ezopen):\/\/.+$/i;
  return protocolRegex.test(url.trim());
}

/**
 * 从路径中获取视频类型
 * @param url 视频路径
 * @returns 视频类型
 * /asdasd.flv?asdaslkg=123 => flv
 * /asdasd.live.flv?asdaslkg=123 => flv
 * /asdasd/hls.m3u8?asdaslkg=123 => hls
 */
export function getVideoType(url: string): string {
  if (!url || typeof url !== "string") {
    return "";
  }

  // 移除查询参数部分（?及其之后的内容）
  const pathWithoutQuery = url.split("?")[0];

  // 转换为小写进行不区分大小写的匹配
  const lowerPath = pathWithoutQuery.toLowerCase();

  // 判断是否以.flv结尾
  if (lowerPath.endsWith(".flv")) {
    return "flv";
  }

  // 判断是否以/hls.m3u8结尾
  if (lowerPath.endsWith("/hls.m3u8")) {
    return "hls";
  }

  // 如果都不匹配，返回空字符串
  return "";
}

export type TzjPlayerPropsType = ExtractPropTypes<typeof TzjPlayerProps>;
export type TzjPlayerInstance = InstanceType<typeof TzjPlayer>;
